export const IP_API_URL = `https://geo.ipify.org/api/v2/country,city`;
export const MAP_URL = `https://tile.openstreetmap.org/{z}/{x}/{y}.png`;
export const ATTRIBUTION = `https://www.openstreetmap.org/copyright`;
export const API_KEY = `at_o54tBe66iCSIGA7h6baJAq2ksgi5J`;
export const TIMEOUT_SEC = 10;
